/** Normalises a Saudi mobile number to E.164 (+9665XXXXXXXX). Returns null when it isn't one. */
const EASTERN = '٠١٢٣٤٥٦٧٨٩';
const PERSIAN = '۰۱۲۳۴۵۶۷۸۹';
/** People type ٠٥٠… on Arabic keyboards; treat those digits as 0–9. */
export function westernDigits(input: string): string {
  return input.replace(/[٠-٩۰-۹]/g, (ch) => String(EASTERN.indexOf(ch) > -1 ? EASTERN.indexOf(ch) : PERSIAN.indexOf(ch)));
}

export function normalizeSaudiMobile(input: string): string | null {
  const digits = westernDigits(input).replace(/[^\d+]/g, '').replace(/^00/, '+');
  let local: string | null = null;
  if (/^\+9665\d{8}$/.test(digits)) local = digits.slice(4);
  else if (/^9665\d{8}$/.test(digits)) local = digits.slice(3);
  else if (/^05\d{8}$/.test(digits)) local = digits.slice(1);
  else if (/^5\d{8}$/.test(digits)) local = digits;
  if (!local) return null;
  return `+966${local}`;
}

